import { gql } from '@apollo/client';

import { entranceAnimationFragment } from '../Animations/query';

export const statsFragment = gql`
  fragment StatsAll on Stats {
    __typename
    sys {
      id
    }
    stat
    entranceAnimation {
      ...EntranceAnimationAll
    }
  }
  ${entranceAnimationFragment}
`;

export const query = gql`
  query StatsQuery($preview: Boolean!, $locale: String!, $id: String!) {
    stats(preview: $preview, locale: $locale, id: $id) {
      ...StatsAll
    }
  }
  ${statsFragment}
`;
